// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".userImg[data-v-29a20a0e] {\n  width: 43px;\n  height: 43px;\n  border-radius: 50%;\n  display: inline-block;\n}\n.userTitle[data-v-29a20a0e] {\n  margin-left: 8px;\n  font-weight: 700;\n  font-size: 1rem;\n  display: inline-block;\n  width: 70px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  vertical-align: middle;\n}", ""]);
// Exports
module.exports = exports;
